<template>
  <div>
    <hi-card v-for="(item, index) in payStageList" :key="item.id" :row-index="index + 1">
      <van-row>
        <span>付款阶段名称：</span>
        <span>{{ item.contractPayStage | dictFilter(payStageOptions) }}</span>
      </van-row>
      <van-row>
        <span>付款阶段类型：</span>
        <span>{{ item.contractStagePayMode | dictFilter(stagePayModeOptions) }}</span>
      </van-row>
      <van-row>
        <span>付款比例%：</span>
        <span>{{ item.payPercent }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'PaymentPlan',
  data() {
    return {
      poCreateHeadId: this.$route.query.businessKey
    }
  },
  props: {
    payStageList: {
      type: Array
    }
  },
  computed: {
    payStageOptions() {
      return this.$store.getters.dicts.contract_pay_stage
    },
    stagePayModeOptions() {
      return this.$store.getters.dicts.contract_stage_pay_mode
    }
  },
  mounted() {
    // this.initData()
  },
  methods: {}
}
</script>
